import React from "react";
import { Grid, Typography } from "@mui/material";
import { Controller } from "react-hook-form";
import TableContent from "./components/TableContent";
import useDevice from "hooks/useDevice";
import TableContentMobile from "./components/TableContentMobile";

const TableField = ({
  control,
  name,
  question,
  listAnswer,
  questionIdx,
  disabled,
}) => {
  const { isPC } = useDevice();
  return (
    <Grid item xs={12} className="!mb-4">
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#00B74F",
          mb: 0.5,
        }}
      >
        Câu {questionIdx + 1}:
      </Typography>
      <Typography
        sx={{
          fontWeight: 600,
          fontSize: "14px",
          color: "#25282B",
          mb: 1,
          wordWrap: "break-word",
        }}
      >
        {question.title}
      </Typography>
      <Controller
        control={control}
        name={name}
        render={({ field, fieldState: { error } }) => {
          if (isPC) {
            return (
              <TableContent
                field={field}
                name={name}
                control={control}
                listAnswer={listAnswer}
                disabled={disabled}
                error={error}
              />
            );
          } else {
            return (
              <TableContentMobile
                field={field}
                name={name}
                control={control}
                listAnswer={listAnswer}
                disabled={disabled}
                error={error}
              />
            );
          }
        }}
      />
      <div
        className="pt-2"
        dangerouslySetInnerHTML={{ __html: question?.description }}
      />
    </Grid>
  );
};

export default TableField;
